export default __webpack_public_path__ + "static/media/riccardo-guggiola.2081b524.jpg";